import type { MvpCharacterId } from '../session/game-session';

export const CHARACTER_SELECT_LAYOUT = Object.freeze({
  header: Object.freeze({
    title: Object.freeze({ x: 640, y: 52 }),
    subtitle: Object.freeze({ x: 640, y: 92 }),
    statusSummary: Object.freeze({ x: 640, y: 122 }),
  }),
  cards: Object.freeze({
    sales: Object.freeze({ centerX: 350, centerY: 375, width: 380, height: 450 }),
    developer: Object.freeze({ centerX: 930, centerY: 375, width: 380, height: 450 }),
    vs: Object.freeze({ x: 640, y: 350 }),
  }),
  cardOffsets: Object.freeze({
    department: Object.freeze({ y: -195 }),
    name: Object.freeze({ y: -166 }),
    preview: Object.freeze({ y: 8 }),
    traits: Object.freeze({ y: 44 }),
    skill1: Object.freeze({ y: 92 }),
    skill2: Object.freeze({ y: 120 }),
    super: Object.freeze({ y: 148 }),
    badge: Object.freeze({ y: 190 }),
  }),
  actions: Object.freeze({
    primary: Object.freeze({ x: 640, y: 630, width: 260, height: 44 }),
    secondary: Object.freeze({ x: 640, y: 678, width: 180, height: 34 }),
  }),
  colors: Object.freeze({
    bg: 0x080d19,
    cardBg: 0x0f172a,
    cardBorder: 0x334155,
    p1Accent: 0x38bdf8,
    p2Accent: 0xf97316,
    bothAccent: 0xfde047,
    cpuAccent: 0x94a3b8,
    unselected: 0x64748b,
    salesTheme: 0x38bdf8,
    developerTheme: 0xf472b6,
  }),
});

export interface CharacterCardData {
  readonly id: MvpCharacterId;
  readonly department: string;
  readonly characterName: string;
  readonly traits: readonly [string, string];
  readonly departmentColor: string;
  readonly themeColor: number;
}

export const CHARACTER_CARD_DATA: Readonly<Record<MvpCharacterId, CharacterCardData>> = Object.freeze({
  sales: Object.freeze({
    id: 'sales',
    department: '営業部',
    characterName: 'SALES',
    traits: ['長身・高リーチ', '名刺と書類で圧倒'] as const,
    departmentColor: '#38bdf8',
    themeColor: 0x38bdf8,
  }),
  developer: Object.freeze({
    id: 'developer',
    department: '開発部',
    characterName: 'DEVELOPER',
    traits: ['低重心・設置トラップ', 'コードとバグで迎撃'] as const,
    departmentColor: '#f472b6',
    themeColor: 0xf472b6,
  }),
});
